import * as React from "react";
import { withPrefix } from "gatsby-link";
import styled, { css } from "styled-components";
import { Container } from "reactstrap";
import { rem } from 'polished';
import Img from "gatsby-image";

import media from '../../helpers/mediaqueries';
import coverImg from "./cover-img.jpg";
import * as coverVideoWebm from "./videos/cover.webm";
import * as coverVideoMp4 from "./videos/cover.mp4";

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #000;
  overflow: hidden;
  display: flex;
  align-items: flex-end;
`;

interface BackgroundVideoProps {
  visible: boolean
}

const BackgroundVideo = styled.video`
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: top;
  object-fit: cover;
  object-position: top;
  z-index: 998;

  ${(props: BackgroundVideoProps) => props.visible && css`
    display: block;
  `}
`;

interface PosterImgProps {
  visible: boolean
}

const PosterImg = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: .4s all;
  z-index: 999;
  opacity: 0;

  ${(props: PosterImgProps) => props.visible && css`
    opacity: 1;
  `}

  & .gatsby-image-outer-wrapper, & .gatsby-image-wrapper {
    width: inherit;
    height: inherit;
  }

  & .gatsby-image-wrapper img {
    object-position: top center !important;
  }
`

const ExtendedContainer = styled(Container)`
  position: relative;
  padding-bottom: 4.5%;
  z-index: 9999;
`;

const HeadText = styled.div`
  margin-bottom: ${rem('30px')};
  max-width: ${rem('220px')};
  font-size: ${rem('64px')};
  font-family: 'Helvetica Neue', sans-serif;
  font-weight: 300;
  line-height: 1;
  letter-spacing: 0.1vw;
  color: #fff;

  ${media.phone`
    font-size: ${rem('48px')};
    max-width: initial;
  `}
`;

const SubText = styled.div`
  max-width: ${rem('300px')};
  height: 5.1em;
  line-height: 1.75;
  font-size: ${rem('15px')};
  font-family: 'ahamonoregular', sans-serif;
  color: rgba(255, 255, 255, 0.7);
  transition: .3s opacity;

  ${media.phone`
    max-width: initial;
  `}

  .wf-loading & {
    opacity: 0;
  }

  .wf-active & {
    opacity: 1;
  }
`;

interface FirstSectionProps {
  bgImage: any
}

class FirstSection extends React.Component<FirstSectionProps, {}> {
  private _video: HTMLVideoElement;

  state = {
    videoVisibility: false,
    imageVisibility: false
  }

  constructor(props: any) {
    super(props);
  }

  startVideo = () => {
    const { _video } = this;

    this.setState({
      imageVisibility: false,
      videoVisibility: true
    });

    _video.play();
  }

  showImage = () => {
    this.setState({
      imageVisibility: true
    })
  }

  render() {
    const { startVideo, showImage } = this;
    const { imageVisibility, videoVisibility } = this.state;
    const { bgImage } = this.props;

    return (
      <Wrapper>
        <PosterImg visible={imageVisibility} onTransitionEnd={startVideo}>
          <Img sizes={bgImage.sizes} fadeIn={false} onLoad={showImage} />
        </PosterImg>
        <BackgroundVideo visible={videoVisibility} innerRef={(video) => { this._video = video; }} playsInline loop>
          <source src={coverVideoWebm} type="video/webm" />
          <source src={coverVideoMp4} type="video/mp4" />
        </BackgroundVideo>
        <ExtendedContainer>
          <HeadText>Planet of the Digital Universe</HeadText>
          <SubText>
            You will find the best of people, works, ideas, and designs in our
            agency.
          </SubText>
        </ExtendedContainer>
      </Wrapper>
    )
  }
}

export default FirstSection;



// WEBPACK FOOTER //
// ./src/components/HomeSection/FirstSection.tsx